import React from 'react'

export default function Loading({ label }: { label?: string }) {
  return (
    <div className="card">
      <div className="muted">{label || 'Loading...'}</div>
    </div>
  )
}
